<template>
  <div class="new1">
    <div
      class="title-area"
      :style="{ backgroundImage: `url(${banner.img == undefined?'': domain + banner.img})` }"
    >
      <div class="wrap">
        <div class="top-wrap">
          <div class="title">{{ banner.title }}</div>
          <span class="english-title">
            {{ banner.desc }}
          </span>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="crumb-area">
        <div class="crumb-item index" @click="toPage()">首页</div>
        <div class="arrow">
          <img src="../../assets/img/icon/icon_xl2@2x.png" alt="" />
        </div>
        <div class="crumb-item index" @click="toPage(cls)">
          {{ initCrumb(cls) }}
        </div>
        <div class="arrow">
          <img src="../../assets/img/icon/icon_xl2@2x.png" alt="" />
        </div>
        <div class="crumb-item">{{ detail.title }}</div>
      </div>
      <div class="detail">
        <div class="header">
          <div class="title">{{ detail.title }}</div>
          <div class="time">
            <span class="publish"
              >发布时间：{{ initTime(detail.create_time) }}</span
            >
            <span class="read_count">阅读量：{{detail.view_count}}</span>
          </div>
        </div>
        <div class="content" v-html="detail.content"></div>
        <div class="footer">
          <div class="last" @click="toNews(last)">
            上一篇：{{ last == null ? "无" : last.title }}
          </div>
          <div class="next" @click="toNews(next)">
            下一篇：{{ next == null ? "无" : next.title }}
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { newsInfo, banner } from "../../network/http_api";
import { BASEDOMAIN } from "../../common/config";
import Footer from "../../components/footer.vue";
export default {
  data() {
    return {
      domain: "",
      banner: "",
      id: "",
      detail: {
        content: "",
      },
      last: null,
      next: null,
      cls: 0,
    };
  },
  components: {
    Footer,
  },
  mounted() {
    this.domain = BASEDOMAIN;
    this.getBanner();
    this.init();
  },
  methods: {
    initCrumb(cls) {
      if (cls == "" || cls == 0) {
        return "全部";
      } else {
        return cls == 1 ? "公司新闻" : "行业动态";
      }
    },
    init() {
      this.id = this.$route.query.idx;
      this.cls = this.$route.query.cls == 0 ? "" : this.$route.query.cls;
      //console.log('id',this.id);
      // console.log("cls", this.cls);

      this.getData();
    },
    toNews(item) {
      if (item != null) {
        this.$router.push({
          query: {
            idx: item.id,
            cls: this.cls == "" ? 0 : this.cls,
          },
        });
        this.init();
      }
    },
    toPage(id = -1) {
      if (id == -1) {
        this.$bus.$emit("headerIdx", 0);
        document.title = "首页";
        this.$router.push("/");
      }else {
         this.$bus.$emit("headerIdx", 3);
        document.title = "新闻";
        this.$router.push("/news");
       window.sessionStorage.setItem('cls',this.cls)
      }
    },
    async getBanner() {
      let res = await banner(4);
      if (res.code == 200) {
        this.banner = res.data[0];
        //console.log("banner", res.data);
      } else {
        this.$message.error(res.msg);
      }
      //console.log("banner", res);
    },
    initTime(tim) {
      if(tim != null){
 let res = tim.split(" ");
      let t = res[1].split(":");
      return res[0] + " " + t[0] + ":" + t[1];
      }
     
    },
    async getData() {
      let res = await newsInfo(this.id, this.cls);
      if (res.code == 200) {
        this.detail = res.data.info;
        this.last = res.data.last;
        this.next = res.data.next;
      } else {
        this.$message.error(res.msg);
      }
      //console.log("newsres", res);
    },
  },
};
</script>

<style lang="scss" scoped>
.title-area {
  height: 450px;
  background: url("") no-repeat;
  background-size: cover;
  overflow: hidden;
  .top-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 150px;
  }
  .title {
    font-size: 64px;
    font-weight: 600;
    color: #ffffff;
    line-height: 75px;
    margin-bottom: 25px;
  }
  .english-title {
    font-size: 32px;
    font-weight: 400;
    color: #ffffff;
    line-height: 38px;
  }
}
.detail {
  padding: 64px 64px 0;
  background: #fff;
  .header {
    text-align: center;
    font-size: 28px;
    font-weight: 500;
    padding-bottom: 45px;
    border-bottom: 1px solid #e5e6eb;
    margin-bottom: 31px;
    .time {
      margin-top: 10px;
      font-size: 16px;
      color: #606266;
      opacity: 0.7;
      .publish {
      }
      .read_count {
        margin-left: 10px;
      }
    }
  }
  .footer {
    border-top: 1px solid #e5e6eb;
    padding: 24px 0 26px;
    color: #000000;
    font-size: 14px;
    margin-top: 42px;
    cursor: pointer;
    .last {
      margin-bottom: 12px;
    }
  }
}
.crumb-area {
  display: flex;
  margin: 18px 0 23px;
  .crumb-item {
    color: #606266;
  }
  .index {
    cursor: pointer;
  }
  .index:hover {
    color: #1d7bff;
  }
  .arrow {
    width: 18px;
    margin: 0 8px;
    img {
      width: 100%;
    }
  }
}
.new1 {
  // padding-top: 64px;
  min-height: 95vh;
  background: #f5f5f5;
}
.wrap {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 60px;
}
.title-area {
  // margin-top: 40px;
  margin-bottom: 40px;
  .caption {
    font-size: 40px;
    font-weight: 500px;
    margin-bottom: 20px;
  }
  .publish {
    display: flex;
    color: #bbb;
    .publish-name {
      margin-right: 10px;
    }
    .publish-time {
      margin-right: 10px;
    }
    .publish-area {
    }
  }
}
.item {
  margin: 80px 0;
  .cap2 {
    display: flex;
    align-content: center;
    .cap2-left {
      font-size: 25px;
      margin-right: 20px;
    }
    .cap2-right {
      font-size: 20px;
      line-height: 25px;
    }
  }
  p {
    font-size: 18px;
    line-height: 25px;
    margin: 25px 0;
  }
}
.active {
  color: #1d7bff;
}
.soure {
  font-size: 14px;
  color: #bbb;
  margin-top: 40px;
  margin-bottom: 40px;
  line-height: 20px;
}
</style>